
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesItemsBOMGrid extends Serenity.EntityGrid<ECommSalesItemsBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesItemsBOM'; }
        protected getDialogType() { return ECommSalesItemsBOMDialog; }
        protected getIdProperty() { return ECommSalesItemsBOMRow.idProperty; }
        protected getInsertPermission() { return ECommSalesItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesItemsBOMRow.localTextPrefix; }
        protected getService() { return ECommSalesItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}